<template>
  <div class="h-100">
    <team-list
      :me-profile="profileMe.id"
      :is-admin="isMeWorkspaceAdmin"
      :teams="filteredTeams"
      :profiles="profiles"
      :loading="isTeamsLoading"
      @search="onTeamSearch"
      @team-give-kudo="onTeamGiveKudo"
      @team-send-message="onTeamSendMessage"
      @member-give-kudo="onMemberGiveKudo"
      @member-send-message="onMemberSendMessage"
      @invite-users="onInviteUsers"
    />
    <b-modal ref="givekudo" hide-footer size="lg" title="Give a kudo">
      <give-kudo
        :key="givekudo.receiverId"
        :receiver="givekudo.receiver"
        :receiver-type="givekudo.receiverType"
        @submitted="onKudoSubmitted"
      />
    </b-modal>
    <b-modal ref="sendmsg" hide-footer size="lg" title="New message">
      <send-message
        :key="sendmsg.receiverId"
        :receivers="sendmsg"
        @submitted="onMsgSubmitted"
      />
    </b-modal>
    <b-modal ref="inviteuser" hide-footer size="md" title="Send an invitation">
      <invitation-users
        v-if="invitationTeam"
        :team="invitationTeam"
        :max-invitations="20"
        @submitted="onInviteUsersSubmitted"
      />
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TeamList from '@/components/TeamList'
import SendMessage from './SendMessage.vue'
import GiveKudo from './GiveKudo'
import InvitationUsers from './InvitationUsers'
import { RECEIVER_TYPE } from '@/helpers/types'
import { teamsQuery } from '@/helpers/helpers'
import statuses from '@/helpers/statuses'

export default {
  name: 'TeamsList',

  computed: {
    ...mapGetters([
      'profileMe',
      'teamsLoading',
      'teamsWithAll',
      'profiles',
      'isMeWorkspaceAdmin'
    ]),

    filteredTeams() {
      return teamsQuery(this.teamsWithAll, this.profiles, this.queryTeam)
    },

    isTeamsLoading() {
      return this.teamsLoading === statuses.LOADING
    }
  },

  data() {
    return {
      queryTeam: '',
      givekudo: {
        receiver: null,
        receiverType: null
      },
      sendmsg: [],
      invitationTeam: null
    }
  },

  mounted() {
    if (this.teamsLoading !== statuses.LOADED) {
      this.$store.dispatch('fetchTeams')
    }
  },

  methods: {
    onTeamSearch(search) {
      this.queryTeam = search
    },

    onTeamSendMessage(team) {
      this.sendmsg = [{ receiver: team, type: RECEIVER_TYPE.TEAM }]
      this.$refs.sendmsg.show()
    },

    onMemberSendMessage(profile) {
      this.sendmsg = [{ receiver: profile, type: RECEIVER_TYPE.USER }]
      this.$refs.sendmsg.show()
    },

    onMsgSubmitted() {
      this.$refs.sendmsg.hide()
    },

    onTeamGiveKudo(team) {
      this.givekudo = {
        receiver: team,
        receiverType: RECEIVER_TYPE.TEAM
      }
      this.$refs.givekudo.show()
    },

    onMemberGiveKudo(profile) {
      this.givekudo = {
        receiver: profile,
        receiverType: RECEIVER_TYPE.USER
      }
      this.$refs.givekudo.show()
    },

    onKudoSubmitted() {
      this.$refs.givekudo.hide()
    },

    onInviteUsers(team) {
      this.invitationTeam = team
      this.$refs.inviteuser.show()
    },

    onInviteUsersSubmitted() {
      this.$refs.inviteuser.hide()
    }
  },

  components: {
    TeamList,
    GiveKudo,
    SendMessage,
    InvitationUsers
  }
}
</script>
